import "./select-multiple.css";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import { SelectMultipleValue, ExternalSourceSuggestions, SelectMultipleCallbacks, SelectMultipleComponentParams } from "./select-multiple-models";
export class SelectMultipleComponent {
    propKey: string;
    propValue: string;
    value$: KnockoutObservable<string> = ko.observable('').extend({ notify: 'always' });
    valueMinLength: number;
    selected$: KnockoutObservableArray<SelectMultipleValue> = ko.observableArray([]);
    list$: KnockoutObservableArray<SelectMultipleValue> = ko.observableArray([]);
    listFiltered$: KnockoutObservableArray<SelectMultipleValue> = ko.observableArray([]);
    disabled: boolean;
    externalSourceSuggestions?: ExternalSourceSuggestions;
    delayedValue: KnockoutComputed<string>;
    KeepCase: boolean;
    Callbacks: SelectMultipleCallbacks;

    constructor(params: SelectMultipleComponentParams, componentElement: HTMLElement) {
        if (!params) {
            throw new Error('Params are not set');
        }
        this.propKey = params.propKey || 'key';
        this.propValue = params.propValue || 'value';
        this.valueMinLength = params.valueMinLength || 1;
        this.selected$ = params.selected || ko.observableArray([]);
        this.list$ = params.list || ko.observableArray([]);
        this.disabled = params.disabled || false;
        this.externalSourceSuggestions = params.externalSourceSuggestions;
        this.setFilteredList(null);
        
        this.delayedValue = ko.pureComputed<string>(this.value$)
            .extend({ rateLimit: { method: "notifyWhenChangesStop", timeout: 700 } });
        
        this.Callbacks = {};
        this.Callbacks.OnNewItem = params.onNewItem;
        this.Callbacks.OnDeletedItem = params.onDeletedItem;
        this.KeepCase = params.keepCase || false;

        this.InitSubscribes();
    }
    onInputKeyup(_, event): void {
        if (event.key === 'Enter') {
            this.setSelectedItem();
        }
    }
    onBlur(_, event): void {
        this.setSelectedItem();
    }
    onRemoveSelectedClick(item: SelectMultipleValue): void {
        this.selected$.remove(item);
        if (typeof this.Callbacks.OnDeletedItem === "function") {
            this.Callbacks.OnDeletedItem(item);
        }
        this.setFilteredList();
    }
    onOptionMouseDown(item, event) {
        event.preventDefault();
        this.setSelectedItem(item);
    }

    /**
     * Initializes the Subscribes for this ViewModel
     * */
    protected InitSubscribes() {
        this.value$.subscribe((value: string) => {
            if (!value) {
                return;
            }
            if (!this.externalSourceSuggestions) {
                this.setFilteredList(value);
            }
        });

        this.delayedValue.subscribe(function (value) {
            if (!this.externalSourceSuggestions) {
                return;
            }
            if (value)
                this.getTips(value).then(_ => this.setFilteredList(value));
        }, this);
    }

    private setFilteredList(value: string = this.value$()): void {
        const list: SelectMultipleValue[] = this.list$();
        if (!list) {
            return;
        }
        const selected: SelectMultipleValue[] = this.selected$();
        if (!selected) {
            this.listFiltered$(list);
            return;
        }
        const listFiltered: SelectMultipleValue[] = !!value
            ? list.filter((l: SelectMultipleValue) => !this.isAnySelectedKeyMatch(selected, ko.unwrap(l[this.propValue]))
                && ko.unwrap(l[this.propValue]).toLowerCase().indexOf(value.toLowerCase()) !== -1)
            : list.filter((l: SelectMultipleValue) => !this.isAnySelectedKeyMatch(selected, ko.unwrap(l[this.propValue])));
        this.listFiltered$(listFiltered);
    }
    private isAnySelectedKeyMatch(selected: SelectMultipleValue[], listValue: string): boolean {
        return selected.some((s: SelectMultipleValue) => s[this.propValue] && listValue === ko.unwrap(s[this.propValue]));
    }
    private setSelectedItem(newItem?: SelectMultipleValue): void {
        const selected: SelectMultipleValue[] = this.selected$() || [];
        let value: string = (this.value$() || '');
        if (this.KeepCase === false) {
            value = value.toLowerCase();
        }
        if (newItem) {
            value = ko.unwrap(newItem[this.propValue]);
        }
        if (value === '')
            return;
        if (!selected.some((s: SelectMultipleValue) => ko.unwrap(s[this.propValue]) === value)) {
            const item: SelectMultipleValue = newItem ??
                this.listFiltered$().filter((l: SelectMultipleValue) => ko.unwrap(l[this.propValue]).toLowerCase() === value)[0];

            let itemToAdd = item || {
                [this.propValue]: ko.observable(value)
            }
            let newArray = this.selected$();
            newArray.push(itemToAdd)
            this.selected$(newArray);
            if (typeof this.Callbacks.OnNewItem === "function") {
                this.Callbacks.OnNewItem(itemToAdd);
            }

            this.listFiltered$([]);
            this.value$('');
        }
    }
    private getTips(phrase: string) {
        return Bao.post(this.externalSourceSuggestions.urlSearch, JSON.stringify({
            [this.externalSourceSuggestions.phraseFieldName]: phrase,
            [this.externalSourceSuggestions.idFieldName]: this.externalSourceSuggestions.rootId,
            [this.externalSourceSuggestions.pageSizeName]: 20
        })).then((result) => ko.map.fromJS(result, this.list$));
    }
}
